import { Button, Table } from "reactstrap";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";

import { confirm } from "components/Confirmation";

import ordemServicoService from "services/OrdemServicoService";

import Item from "./Item";
import ModalIncluir from "./ModalIncluir";
import ModalAlterar from "./ModalAlterar";
import ModalHistorico from "./ModalHistorico";

import './index.scss'
import ModalDetalhes from "./ModalDetalhes";
import { showLoading } from "components/Loading";
import { hideLoading } from "components/Loading";
import { erroInesperado } from "services/Utils";
import { StatusOrdemServicoEnum } from "services/OrdemServicoService";
import { formatNumber } from "services/Utils";
import { PapelEnum, ehPapelGestorContrato } from "services/PerfilService";
import AppContext from "AppContext";
import { totalizar } from "services/Utils";
import { TipoContratoEnum } from "services/ContratoService";

export default function Items({ idOrdemServico, idContrato, os, onChangeTotal, onReloadItens, onChange, itens, edit }) {
  const [configModalIncluir, setConfigModalIncluir] = useState()
  const [configModalAlterar, setConfigModalAlterar] = useState()
  const [configModalHistorico, setConfigModalHistorico] = useState()
  const [configModalDetalhes, setConfigModalDetalhes] = useState()
  const { state } = useContext(AppContext)

  const podeIncluir = useMemo(() => {
    if (!(state?.user?.acoes || []).includes('os.gerenciar_item'))
      return false

    if (os.contrato_tipoContrato == TipoContratoEnum.NORMAL)
      return (state.user.perfil.idTipo == PapelEnum.FISCAL || state.user.perfil.idTipo == PapelEnum.ADMIN || ehPapelGestorContrato(state.user.perfil.idTipo))

    if (os.contrato_tipoContrato == TipoContratoEnum.SEMAFORICO)
      return state.user.perfil.idTipo == PapelEnum.GESTOR_EMPRESA && os.idStatus == StatusOrdemServicoEnum.PENDENTE
  }, [state.user.perfil.idTipo, state.user.acoes, os])

  useEffect(() => {
    if (onChangeTotal && !!itens) {
      onChangeTotal({
        total: totalizar(itens.map(el => el.precoTotal)),
        totalExecutado: totalizar(itens.map(el => el.precoUnitario * el.quantidadeExecutada))
      })
    }
  }, [itens])

  const itensEmCorrecao = useMemo(() => {
    if (!itens || itens.length == 0 || !os || os.idStatus != StatusOrdemServicoEnum.EM_FASE_CORRECAO) return []
    return os.correcoes.map(el => el.itens).reduce((acc, itens) => [...acc, ...itens], [])
  }, [itens, os])

  const handleClick = async (event, source) => {
    if (event == 'delete') {
      const justificativaObrigatoria = os?.idStatus != StatusOrdemServicoEnum.PENDENTE
      confirm({
        header: 'Excluir item',
        showInput: true,
        inputLabel: 'Justificativa',
        inputPlaceholder: 'Descreva o motivo da exclusão do item',
        inputRequired: justificativaObrigatoria,
        inputRequiredMessage: 'A justificativa é obrigatória para excluir o item nesta OS.',
        confirmButtonText: 'Excluir',
        refuseButtonText: 'Cancelar',
        onConfirm: async ({ inputValue }) => {
          const justificativa = (inputValue || '').trim()

          try {
            showLoading()
            const res = await ordemServicoService.deleteItem(idOrdemServico, source.id, justificativa)
            hideLoading()
            if (res.success) {
              toast("O registro foi excluído com sucesso")
              onChange ? onChange() : onReloadItens && onReloadItens()
            } else {
              toast(res.message || "Erro ao excluir o registro")
            }
          } catch (ex) {
            hideLoading()
            console.error(ex)
            erroInesperado()
          }
        }
      })
    } else if (event == 'edit') {
      setConfigModalAlterar({
        idOrdemServico,
        os,
        selecionado: source
      })
    } else if (event == 'detail') {
      setConfigModalDetalhes({
        idOrdemServico,
        os,
        idItem: source.id
      })
    } else if (event == 'history') {
      setConfigModalHistorico({
        idOrdemServico,
        selecionado: source
      })
    }
  }

  const handleIncluir = async () => {
    setConfigModalIncluir({
      idOrdemServico,
      os,
      tipoContrato: os.contrato_tipoContrato
    })
  }

  const handleChangeModalIncluir = () => {
    onChange ? onChange() : onReloadItens && onReloadItens()
  }

  const handleChangeModalAlterar = () => {
    onChange ? onChange() : onReloadItens && onReloadItens()
  }

  return (
    <div className="contratos-items">
      {edit && (
        <div className="text-right mb-2">
          <Button color="primary" onClick={() => handleIncluir()}>Incluir</Button>
        </div>
      )}
      <Table className="align-items-center table-flush" responsive>
        <thead>
          <tr>
            <th>Item</th>
            <th>Descrição</th>
            <th className="text-right">Valor Unit.</th>
            {os.contrato_tipoContrato == TipoContratoEnum.NORMAL ? (
              <>
                <th className="text-right">Quantidade</th>
                <th className="text-right">% Execução</th>
                <th className="text-right">Saldo Execução</th>
              </>
            ) : (
              <th className="text-right">Quantidade</th>
            )}
            <th className="text-right">Valor Total Previsto</th>
            <th className="text-right">Valor Total Executado</th>
            <th className="text-right">Saldo de Custo</th>
            <th style={{ width: 120 }}></th>
          </tr>
        </thead>
        <tbody>
          {itens && itens.map(el => <Item key={el.id} {...el} os={os} onClick={handleClick} edit={edit} tipoContrato={os.contrato_tipoContrato} />)}
        </tbody>
        {itens && (
          <tfoot>
            <tr>
              <td colSpan={os.contrato_tipoContrato == TipoContratoEnum.NORMAL ? 6 : 4} className="text-right"><strong>Total:</strong></td>
              <td className="text-right" style={{ fontSize: 18 }}>
                R$ {formatNumber(totalizar(itens.map(el => el.precoTotalPrevisto)))}
              </td>
              <td className="text-right" style={{ fontSize: 18 }}>
                R$ {formatNumber(totalizar(itens.map(el => el.precoTotalExecutado)))}
              </td>
              <td className="text-right" style={{ fontSize: 18 }}>
                R$ {formatNumber(totalizar(itens.map(el => el.saldoCusto)))}
              </td>
              <td>&nbsp;</td>
            </tr>
          </tfoot>
        )}
      </Table>

      {podeIncluir && (
        <>
          <ModalIncluir
            config={configModalIncluir}
            onClosed={() => setConfigModalIncluir()}
            onChange={() => handleChangeModalIncluir()}
            itensAtuais={itens}
            idContrato={idContrato}
          />

          <ModalAlterar
            config={configModalAlterar}
            onClosed={() => setConfigModalAlterar()}
            onChange={() => handleChangeModalAlterar()}
          />
        </>
      )}

      <ModalHistorico
        config={configModalHistorico}
        onClosed={() => setConfigModalHistorico()}
      />

      <ModalDetalhes
        config={configModalDetalhes}
        onClosed={() => setConfigModalDetalhes()}
      />
    </div>
  )
}